import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Thumbnail, Alert } from 'react-bootstrap';
import Truncate from 'react-truncate';
import { Doc, DocStatuses, Subject } from '../../common/models';

import './DocThumbnail.css';

interface DocThumbnailProps {
  doc: Doc;
  link: string;
  showSubject?: boolean;
}

interface TitleProps { title: string; }

interface SubjectProps { subject: Subject; }

const Title = ({ title }: TitleProps) => (
  <Truncate lines={2} className="title">{title}</Truncate>
);

const Subject = ({ subject }: SubjectProps) => (
  <p className="subject">{subject.user.displayName || subject.user.name}</p>
);

export const DocThumbnail = ({ doc, link, showSubject = true }: DocThumbnailProps) => {
  const url = doc.thumbnail && doc.thumbnail.url;
  return (
    <LinkContainer to={link} className="DocThumbnail">
      <Thumbnail src={url} alt={doc.title ? `${doc.title} thumbnail` : 'Document thumbnail'}>
        <div>
          {doc.subject && showSubject && <Subject subject={doc.subject}/>}
          {doc.title && <Title title={doc.title}/>}
        </div>
        {doc.status === DocStatuses.UNFILED &&
          <div className="text-danger">
            <i className="fa fa-warning" />{' '}
            <span>Not Filed</span>
          </div>
        }
        {doc.status === DocStatuses.DELETED &&
          <Alert bsStyle="danger" className="text-center delete-message">
            Deleted
          </Alert>
        }
      </Thumbnail>
    </LinkContainer>
  );
};



// WEBPACK FOOTER //
// ./src/DocListView/DocThumbnail/DocThumbnail.tsx